/* eslint-disable @typescript-eslint/member-ordering */
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import { EnvironmentConfig } from '@core/config-models';
import type { LinkFieldValue } from '@core/jss-models';
import { JssStateMetaTitleUpdated } from '@core/jss-routing';
import { getSettingsValue } from '@core/settings';
import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';

import { NotFoundComponent } from '../not-found/not-found.component';

@Component({
  selector: 'wl-not-found-container',
  templateUrl: './not-found-container.component.html',
  styleUrls: [],
  standalone: true,
  imports: [NotFoundComponent],
})
export class NotFoundContainerComponent implements OnInit, OnDestroy {
  private readonly store$ = inject(Store);
  private readonly environmentConfig =
    inject<EnvironmentConfig>(ENVIRONMENT_CONFIG);

  private readonly errorCodeNotFoundSelector = () =>
    getSettingsValue<LinkFieldValue>('errorCodes', '404');
  private readonly errorCodeNotFound$ = this.store$.pipe(
    select(this.errorCodeNotFoundSelector())
  );
  private readonly onDestroy$ = new Subject();

  ngOnInit() {
    this.errorCodeNotFound$
      .pipe(
        filter((val) => val !== null),
        take(1),
        takeUntil(this.onDestroy$)
      )
      .subscribe(
        (errorName) =>
          errorName &&
          this.store$.dispatch(
            new JssStateMetaTitleUpdated(errorName.toString())
          )
      );
  }

  ngOnDestroy() {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

  get brand() {
    return this.environmentConfig.brand;
  }
}
